import axios from 'axios';

// 临时硬编码用于测试（请在测试后恢复环境变量方式）
const API_BASE_URL = 'https://data-management-system-production.up.railway.app';
// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API_ENDPOINT = `${API_BASE_URL}/api`;

class DataServiceClass {
  async getRecords(page = 1, limit = 10, search?: string) {
    const params: any = { page, limit };
    if (search) {
      params.search = search;
    }
    const response = await axios.get(`${API_ENDPOINT}/data`, { params });
    return response.data;
  }

  async createRecord(data: any) {
    const response = await axios.post(`${API_ENDPOINT}/data`, { data });
    return response.data;
  }

  async updateRecord(id: number, data: any) {
    const response = await axios.put(`${API_ENDPOINT}/data/${id}`, { data });
    return response.data;
  }

  async updateLLMResult(id: number, llmResult: string) {
    const response = await axios.put(`${API_ENDPOINT}/data/${id}/llm-result`, { llmResult });
    return response.data;
  }

  async updateLLMThinkingResult(id: number, llmResult: string) {
    const response = await axios.put(`${API_ENDPOINT}/data/${id}/llm-thinking-result`, { llmResult });
    return response.data;
  }

  async updateDeliveryStatus(id: number, isDelivered: boolean) {
    const response = await axios.put(`${API_ENDPOINT}/data/${id}/delivery-status`, { isDelivered });
    return response.data;
  }

  async regenerateLLMResult(id: number) {
    const response = await axios.post(`${API_ENDPOINT}/data/${id}/regenerate-llm`);
    return response.data;
  }

  async deleteRecord(id: number) {
    const response = await axios.delete(`${API_ENDPOINT}/data/${id}`);
    return response.data;
  }

  async uploadTarotImage(recordId: number, formData: FormData) {
    const response = await axios.post(`${API_ENDPOINT}/data/${recordId}/upload-tarot`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async downloadGeneratedImage(recordId: number) {
    const response = await axios.get(`${API_ENDPOINT}/data/${recordId}/download-image`, {
      responseType: 'blob',
    });
    return response;
  }

  getTarotImageUrl(filename: string) {
    // 如果是完整的URL（Cloudinary），直接返回
    if (filename.startsWith('http://') || filename.startsWith('https://')) {
      return filename;
    }
    // 否则构建API路径（向后兼容本地文件）
    return `${API_ENDPOINT}/data/image/tarot/${filename}`;
  }

  getGeneratedImageUrl(filename: string) {
    // 如果是完整的URL（Cloudinary），直接返回
    if (filename.startsWith('http://') || filename.startsWith('https://')) {
      return filename;
    }
    // 否则构建API路径（向后兼容本地文件）
    return `${API_ENDPOINT}/data/image/generated/${filename}`;
  }

  async getStatistics(startDate: string, endDate: string) {
    const response = await axios.get(`${API_ENDPOINT}/data/statistics`, {
      params: { startDate, endDate }
    });
    return response.data;
  }

  async getUserGroupedStatistics(startDate: string, endDate: string) {
    const response = await axios.get(`${API_ENDPOINT}/data/user-grouped-statistics`, {
      params: { startDate, endDate }
    });
    return response.data;
  }

  async exportStatisticsCSV(startDate: string, endDate: string) {
    const response = await axios.get(`${API_ENDPOINT}/data/export-csv`, {
      params: { startDate, endDate },
      responseType: 'blob'
    });
    return response;
  }

  async extractFromImage(formData: FormData) {
    const response = await axios.post(`${API_ENDPOINT}/data/extract-from-image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }
}

export const DataService = new DataServiceClass();